<template>
    <div class="setup">
        <b-loading :is-full-page="isFullPage" :active.sync="showLoader"></b-loading>
        <form action="" class="form setup-form-block" >
            <div class="form-content-block group">
                <label class="setup-label">{{ 'Maximum conversation attempts' }}</label>
                <div class="row">
                    <div class = "row" v-bind:class="fieldConfigs.max_attempts_during_visits.fieldClass">
                        <label class="input-label label">{{ fieldConfigs.max_attempts_during_visits.label }}</label>
                        <div class="control">
                            <input class="input" 
                            type="text" 
                            v-bind:placeholder="fieldConfigs.max_attempts_during_visits.placeholder"
                            v-bind:name="fieldConfigs.max_attempts_during_visits.name"
                            v-model="formData.max_attempts_during_visits" />
                        </div>
                    </div>
                    <div  class = "row" v-bind:class="fieldConfigs.max_attempts_across_visits.fieldClass">
                        <label class="input-label label">{{ fieldConfigs.max_attempts_across_visits.label }}</label>
                        <div class="control">
                            <input class="input" 
                            type="text" 
                            v-bind:placeholder="fieldConfigs.max_attempts_across_visits.placeholder"
                            v-bind:name="fieldConfigs.max_attempts_across_visits.name"
                            v-model="formData.max_attempts_across_visits" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-content-block group" >
                <label class="setup-label label">Visitor engagement triggers</label>
                    <Behavior 
                        v-bind:entries="conversation_behavior"
                        :campaign_setting_id="settings.campaign_setting_id" 
                        v-on:updateBehavior="updateBehavior" />
            </div>
            <div class="field --form-btn-holder">
                <div class="control --center-align">
                    <a href="" class="button --form-action-btn" @click.prevent="_saveTriggers($event)">Save</a>
                <!--<button class="button --form-action-btn" @click="_saveTriggers($event)">
                            Save
                </button>-->
                </div>
            </div>
               
           
        </form>
    </div>
</template>
<script>
import { mapGetters, mapState  } from 'vuex';
import { isEmpty, cloneDeep, forEach } from 'lodash';
import { initSetOptimization } from './scripts/init';
import settingsFormMixins from 'SrcRoot/mixins/form/settings_form';
import Behavior from './partial/Behavior';
//import VueUnsavedChangesDialog from 'vue-unsaved-changes-dialog';
import {unsavedChangesTitle, unsavedChangesSubtitle} from 'SrcRoot/mixins/modal';
import formMixins from 'SrcRoot/mixins/form';
import modalMixins from 'SrcRoot/mixins/modal';
import warningModalMixin from "SrcRoot/modules/Editor/mixins/warning_modal_mixin";
import EventBus from "@/utils/event-bus";

export default {
    name: 'TriggerSelection',
    mixins: [
        settingsFormMixins,
        modalMixins,
        formMixins,
        warningModalMixin
    ],
    components: {
        Behavior,
        //VueUnsavedChangesDialog
    },
    mounted() {
        this.$nextTick(() => {
            EventBus.$on(`userResponse`, this.handleUserResponse); 
        });
    },
    beforeDestroy() {
         EventBus.$off(`userResponse`, this.handleUserResponse);
    },
    computed: {
        ...mapGetters('campaigns', [
            'currentCampaign'
        ]),
        ...mapState('editor', {
            showWarningModal: (state) => state.showWarningModal,
            userResponded:(state) => state.userResponded,
        }),
        settings() {
            if (isEmpty(this.currentCampaign)) {
                return {};
            }
            return this.currentCampaign.settings;
        },
        max_attempts_across_visits() {
            if (isEmpty(this.settings)) return '';
            else return this.settings.max_attempts_across_visits;
        },
        max_attempts_during_visits() {
            if (isEmpty(this.settings)) return '';
            else return this.settings.max_attempts_during_visits;
        }
    },
    beforeRouteLeave(to, from, next) {
        // set by WarningModal if user has NOT responded - then beep and return
        if (this.showWarningModal && !this.userResponded) { 
            this._beep();
            return; 
        } 
        if (!(this.isComponentDirty())) {
            EventBus.$emit('editor:closeWarningModal');
            next();
        } else if (this.isTriggerSelectionValid(false)) {
            this.next = next; // so call back has access to the next route
            this.askUserSaveOrDiscard();
        }
    },
    created() {
       
    },
    data() {
        return {
            formData: {},
            fieldConfigs: {},
            isFullPage: false,
            showLoader: false,
            conversation_behavior: [],
            from_conversation_behavior:[],
            form_conversation_behavior: [],
            showError:false,
            resetShowError:false,
            unsavedChangesTitle,
            unsavedChangesSubtitle,
            thisComponent:this,
            showDialog:false,
            validationErrorMsg:"",
            gotonextroute:"",
            triggerErrorMsgs:[],
            next:""

        };
    },
    methods: {
        initialSettingsData() {
            return initSetOptimization();
        },
        handleUserResponse(response) {
            EventBus.$emit('editor:closeWarningModal');
            const {userResponse} = response.data;
            if (userResponse == 'make-change') this.makeChanges(); // save and then go to next route
            else this.keepAsIs();
        },
        keepAsIs() { // discard changes
            this.next(); // go to the next route
        },
        makeChanges() { // keeping changes - and then going to next route save changes
            this.showLoader = true;
            this.formData = {
                ...this.formData,
                conversation_behavior: this.form_conversation_behavior,
            }
            return this
                .saveSettings()
                .then(() => {
                    this.mergeSettingsData();
                    this.showLoader = false;
                    this.next();
                    
                });
        },

        askUserSaveOrDiscard() {
            this._showWarningModal([{type:'single', "sceneName": "", 'msg':`You have unsaved data. Would you like to save  or discard?`}], 'Discard', 'Save', 'twoChoices','ackUserResponse',this.handleUserResponse,'TriggerSelection', "", "hideTurnoffCheckbox",'short-warning-modal');
        },
       
        getErrorMessage() {
            let errorMsg = this.validationErrorMsg;
            return {[errorMsg]: this.showError}
        },
        _saveOrUpdateForm() {
            return this.saveTriggerSelection();
        },
        isTriggerSelectionValid(showErrorModal) {
            let secondsOnPage1, secondsOnWebsite1, formValid = true;
            const pageviews = this.form_conversation_behavior.find(o =>  (o.behavior_type === 'pageViews'));
            const seconds_on_page = this.form_conversation_behavior.find(o =>  (o.behavior_subtype === 'secondsOnPage')); 
            const seconds_on_website = this.form_conversation_behavior.find(o =>  (o.behavior_subtype === 'secondsOnWebsite'));
            if (pageviews == undefined || seconds_on_page == undefined || seconds_on_website == undefined) {

                if (showErrorModal) this._showWarningModal([{type:'single', "sceneName": "", 'msg':`You are saving a form without all the required fields?`}], 'O.K., got it', '', 'singleChoice','doNotAckUserResponse','','TriggerSelection', "", "hideTurnoffCheckbox",'short-warning-modal');
            
                return false;
            }
            const {behavior_value:pageCount, behavior_logical_operator: pageViewOperand} = pageviews;
            const {behavior_value:secondsOnPage, behavior_logical_operator: timeOperand} = seconds_on_page;
            const {behavior_value:secondsOnWebsite} = seconds_on_website;

            this.triggerErrorMsgs = [];
            if  (isEmpty(this.formData.max_attempts_during_visits) || isEmpty(this.formData.max_attempts_across_visits)) 
                if (showErrorModal) this.triggerErrorMsgs.push({type:'fatal', "sceneNames": "", 'msg':`Please enter value for max attempts during visit and across visits`});
            if (Number(this.formData.max_attempts_during_visits) > Number(this.formData.max_attempts_across_visits)) 
                if (showErrorModal) this.triggerErrorMsgs.push({type:'fatal', "sceneNames": "", 'msg':`Max attempts during visit cannot be greater than across visits`});
            if (isEmpty(pageCount) || isNaN(pageCount) && pageViewOperand == 'and') 
                if (showErrorModal) this.triggerErrorMsgs.push({type:'fatal', "sceneNames": "", 'msg':`Enter a valid page view count`});
            if (timeOperand == 'and' && ( isEmpty(secondsOnPage) || isNaN(secondsOnPage) || isEmpty(secondsOnWebsite) || isNaN(secondsOnWebsite)))
                if (showErrorModal) this.triggerErrorMsgs.push({type:'fatal', "sceneNames": "", 'msg':`Enter valid seconds on page and/or seconds on website`}); 
            if (Number(secondsOnPage) > Number(secondsOnWebsite)) 
                if (showErrorModal) this.triggerErrorMsgs.push({type:'single', "sceneNames": "", 'msg':`Seconds on page cannot be greater than seconds on website`}); 
            if (isEmpty(this.triggerErrorMsgs)) return true;
            else {
                if (showErrorModal) this._showWarningModal(this.triggerErrorMsgs, 'O.K., got it', '', 'singleChoice', 'doNotAckUserResponse',undefined, 'TriggerSelection', "", "hideTurnoffCheckbox",'warning-modal');
                return false;
            } 
        },
        
        _saveTriggers($event) {
            $event.preventDefault();
            if (this.isTriggerSelectionValid(true)) {
                this.saveTriggerSelection();
            } 
        },
        saveTriggerSelection() {
            this.showLoader = true;
            this.formData = {
                ...this.formData,
                conversation_behavior: this.form_conversation_behavior,
            }
            return this
                .saveSettings()
                .then(() => {
                    this.mergeSettingsData();
                    this.showLoader = false;
                    this.clearDirtyFields();
                    if (typeof this.gotonextroute === 'function') {
                        this.gotonextroute();
                    }
                    
                });
        },
        mergeFormData() {
            const conversation_behavior = cloneDeep(this.formData.conversation_behavior);
            this.from_conversation_initiation = 'manualOptimization';
            this.conversation_behavior = [...conversation_behavior];
            this.from_conversation_behavior = cloneDeep(this.formData.conversation_behavior);
        },
        updateBehavior(behavior_data) {
            this.form_conversation_behavior = [...behavior_data];
        },
        areBehaviousDirty(oldr, newr) {
            if ((oldr === undefined) && (newr === undefined)) return false;
            else if ((oldr === undefined) || (newr === undefined)) return true;
            else if ((oldr.behavior_logical_operator !== newr.behavior_logical_operator) || (oldr.behavior_value !== newr.behavior_value)) return true;
            return false;
        },
        isBehaviorDirty() {
            let old_pageviews = this.from_conversation_behavior.find(o =>  (o.behavior_type === 'pageViews')),
                new_pageviews = this.form_conversation_behavior.find(o =>  (o.behavior_type === 'pageViews')),
                old_seconds_on_page = this.from_conversation_behavior.find(o =>  (o.behavior_subtype === 'secondsOnPage')),
                new_seconds_on_page = this.form_conversation_behavior.find(o =>  (o.behavior_subtype === 'secondsOnPage')),
                old_seconds_on_website = this.from_conversation_behavior.find(o =>  (o.behavior_subtype === 'secondsOnWebsite')),
                new_seconds_on_website = this.form_conversation_behavior.find(o =>  (o.behavior_subtype === 'secondsOnWebsite'));
            if ((this.areBehaviousDirty(old_pageviews, new_pageviews)) 
                || (this.areBehaviousDirty(old_seconds_on_page, new_seconds_on_page))
                || (this.areBehaviousDirty(old_seconds_on_website, new_seconds_on_website))) {
                return true;
            }
            return false;
        },
        isAttemptsDirty() {
            if (this.formData.max_attempts_during_visits != this.max_attempts_during_visits || this.formData.max_attempts_across_visits != this.max_attempts_across_visits) return true;
            else return false;
        },
        isComponentDirty() {
            if (this.formData.conversation_behavior.length !== this.form_conversation_behavior.length ) {
                return true;
            } else if (this.isBehaviorDirty() || this.isAttemptsDirty()) {
                return true;
            }
            return false;
        }
    },
    watch: {
        form_conversation_behavior: {
            deep: true,
            handler(to) {
                if (to === undefined || isEmpty(to)) {
                    return;
                } else {
                    if (this.resetShowError) {
                        this.resetShowError = false;
                        this.showError = false;
                    }
                    
                }
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import "SrcRoot/modules/Campaign/components/setup/scss/setup.scss";
.setup {
    position:relative;
    .setup-form-block {
        .field {
        }
    }
    .field.custom-field p.is-danger {
        font-size:12px;
        position:absolute !important;
        top:20% !important;
        left: 50%;
        transform: translateX(-50%);
        padding: 5px;
        background-color: $light-pink;
        border-radius: 5px;
    }
    
}
</style>

